/* ==========================================================================
   Zapatos Obi — predictive-search.js
   Overlay de búsqueda a pantalla completa:
   - Al abrir: "Productos populares" (más vendidos, /collections/all?sort_by=best-selling).
   - Al escribir (>=2): resultados en rejilla + filtros a la izquierda (/search?...&section_id=search-overlay).
   - Filtrar dentro del overlay re-consulta /search sin salir (Section Rendering API).
   - Enter (submit del form) navega a la página /search completa.
   ========================================================================== */
(function () {
  'use strict';

  var MIN_CHARS = 2;
  var routes = (window.Obi && Obi.routes) || '/';
  var controller = null;
  var popularLoaded = false;
  var priceTimer = null;

  // ── Productos vistos recientemente (localStorage) ──────────────────────────
  var RV_KEY = 'obi:recently-viewed';

  function rvGet() {
    try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return []; }
  }

  function currentHandle() {
    return (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
  }

  /* Si estamos en una ficha de producto, guarda su handle (el más reciente primero). */
  function rvTrack() {
    var handle = currentHandle();
    if (!handle) return;
    var list = rvGet().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
  }
  rvTrack();

  function overlay() {
    return document.querySelector('[data-search-overlay]');
  }
  function popularBox() {
    var o = overlay();
    return o ? o.querySelector('[data-search-popular]') : null;
  }
  function resultsBox() {
    var o = overlay();
    return o ? o.querySelector('[data-predictive-search-results]') : null;
  }
  function searchInput() {
    var o = overlay();
    return o ? o.querySelector('input[type="search"]') : null;
  }

  /* Coloca el overlay justo bajo la cabecera real (cuenta la barra de anuncio
     y el estado de scroll), no solo el alto del header sticky. */
  function positionOverlay() {
    var ov = overlay();
    var hc = document.querySelector('.header-wrapper') || document.querySelector('header-controller');
    if (!ov || !hc) return;
    var bottom = Math.max(0, Math.round(hc.getBoundingClientRect().bottom));
    ov.style.setProperty('--search-top', bottom + 'px');
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  /* Extrae el contenido interno de la sección renderizada (Section Rendering API). */
  function extractSection(html, id) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var wrap = doc.getElementById('shopify-section-' + id) || doc.querySelector('.shopify-section');
    return wrap ? wrap.innerHTML : html;
  }

  /* Slider de precio (doble tirador): sincroniza relleno + cajas numéricas. */
  function syncPriceSlider(changed) {
    var wrap = changed.closest('[data-price-slider]');
    if (!wrap) return;
    var minR = wrap.querySelector('[data-range-min]');
    var maxR = wrap.querySelector('[data-range-max]');
    var fill = wrap.querySelector('[data-slider-fill]');
    var top = parseFloat(wrap.getAttribute('data-max')) || 100;
    var lo = parseFloat(minR.value);
    var hi = parseFloat(maxR.value);
    if (lo > hi) {
      if (changed === minR) { minR.value = hi; lo = hi; }
      else { maxR.value = lo; hi = lo; }
    }
    if (fill) {
      fill.style.left = (lo / top) * 100 + '%';
      fill.style.right = 100 - (hi / top) * 100 + '%';
    }
    var price = wrap.parentElement.querySelector('.facets__price');
    if (price) {
      var nums = price.querySelectorAll('input[type="number"]');
      if (nums[0]) nums[0].value = lo > 0 ? lo : '';
      if (nums[1]) nums[1].value = hi < top ? hi : '';
    }
  }

  function syncSliders(scope) {
    (scope || document)
      .querySelectorAll('[data-price-slider] [data-range-min]')
      .forEach(function (r) { syncPriceSlider(r); });
  }

  function showPopular() {
    if (controller) controller.abort();
    var p = popularBox(), r = resultsBox();
    if (p) p.hidden = false;
    if (r) { r.hidden = true; r.innerHTML = ''; }
  }
  function showResults() {
    var p = popularBox(), r = resultsBox();
    if (p) p.hidden = true;
    if (r) r.hidden = false;
  }

  function loadPopular() {
    if (popularLoaded) return;
    var p = popularBox();
    if (!p) return;
    popularLoaded = true;
    var cur = currentHandle();
    var handles = rvGet().filter(function (h) { return h !== cur; }).slice(0, 8);
    if (handles.length) {
      renderRecentlyViewed(p, handles);
    } else {
      // sin productos vistos → caer a "Productos populares" (más vendidos)
      fetch(routes + 'collections/all?sort_by=best-selling&filter.v.availability=1&section_id=search-popular')
        .then(function (r) { return r.text(); })
        .then(function (html) { p.innerHTML = extractSection(html, 'search-popular'); })
        .catch(function () { popularLoaded = false; });
    }
  }

  /* "Últimos vistos": una tarjeta por handle (orden conservado). */
  function renderRecentlyViewed(container, handles) {
    var label = container.getAttribute('data-recent-label') || 'Últimos vistos';
    container.innerHTML =
      '<div class="search-popular"><h2 class="search-popular__heading"></h2>' +
      '<ul class="product-grid product-grid--flush" role="list"></ul></div>';
    container.querySelector('.search-popular__heading').textContent = label;
    var ul = container.querySelector('ul');
    handles.forEach(function (handle) {
      var li = document.createElement('li');
      ul.appendChild(li);
      fetch(routes + 'products/' + encodeURIComponent(handle) + '?section_id=search-rv-card')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var card = new DOMParser().parseFromString(html, 'text/html').querySelector('.product-card');
          if (card) {
            li.appendChild(card);
            if (window.ObiWishlist) window.ObiWishlist.sync(li);
          } else {
            li.remove();
          }
        })
        .catch(function () { li.remove(); });
    });
  }

  function fetchSearch(queryString) {
    var box = resultsBox();
    if (!box) return;
    if (controller) controller.abort();
    controller = new AbortController();
    // conservar el scroll del cajón de filtros (móvil) al re-renderizar
    var oldDrawer = box.querySelector('.search-overlay__filters');
    var savedScroll = oldDrawer ? oldDrawer.scrollTop : 0;
    box.setAttribute('aria-busy', 'true');
    showResults();
    fetch(routes + 'search?' + queryString + '&section_id=search-overlay', { signal: controller.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        box.innerHTML = extractSection(html, 'search-overlay');
        box.removeAttribute('aria-busy');
        syncSliders(box);
        var newDrawer = box.querySelector('.search-overlay__filters');
        if (newDrawer && savedScroll) newDrawer.scrollTop = savedScroll;
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') box.removeAttribute('aria-busy');
      });
  }

  /* "Cargar más": añade la siguiente página de resultados en el propio overlay. */
  function loadMore(btn) {
    var url = btn.getAttribute('data-search-more');
    if (!url) return;
    btn.disabled = true;
    var u = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=search-overlay';
    fetch(u)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.getElementById('shopify-section-search-overlay') || doc.querySelector('.shopify-section') || doc.body;
        var box = resultsBox();
        var curGrid = box && box.querySelector('.product-grid');
        var newGrid = inner.querySelector('.product-grid');
        if (curGrid && newGrid) {
          Array.prototype.slice.call(newGrid.children).forEach(function (li) {
            curGrid.appendChild(li);
          });
        }
        var newBtn = inner.querySelector('[data-search-more]');
        if (newBtn) {
          btn.setAttribute('data-search-more', newBtn.getAttribute('data-search-more'));
          btn.disabled = false;
        } else {
          btn.remove();
        }
        if (window.ObiWishlist) window.ObiWishlist.sync(box);
      })
      .catch(function () { btn.disabled = false; });
  }

  /* Buscar por texto (resetea filtros). */
  function searchByQuery(query) {
    if (query.length < MIN_CHARS) {
      showPopular();
      return;
    }
    fetchSearch('q=' + encodeURIComponent(query) + '&type=product&filter.v.availability=1&options%5Bprefix%5D=last');
  }

  /* Aplicar filtros del overlay (mantiene la búsqueda actual). */
  function applyFacets() {
    var o = overlay();
    if (!o) return;
    var form = o.querySelector('[data-search-facets-form]');
    if (!form) return;
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (String(value).trim() !== '') params.append(key, value);
    });
    fetchSearch(params.toString());
  }

  var onType = debounce(function (input) {
    searchByQuery(input.value.trim());
  }, 260);

  /* ---- Eventos (delegados: el contenido se reinyecta por AJAX) ---- */

  document.addEventListener('input', function (e) {
    // campo de búsqueda
    if (e.target.matches('[data-predictive-search-form] input[type="search"]')) {
      var clear = overlay() && overlay().querySelector('[data-search-clear]');
      if (clear) clear.hidden = e.target.value.length === 0;
      onType(e.target);
      return;
    }
    // slider de precio (tiradores)
    if (e.target.matches('[data-search-facets-form] [data-range-min], [data-search-facets-form] [data-range-max]')) {
      syncPriceSlider(e.target);
      clearTimeout(priceTimer);
      priceTimer = setTimeout(applyFacets, 500);
      return;
    }
    // precio (cajas numéricas) dentro de los filtros
    if (e.target.matches('[data-search-facets-form] input[type="number"]')) {
      clearTimeout(priceTimer);
      priceTimer = setTimeout(applyFacets, 600);
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-search-facets-form] input[type="checkbox"], [data-search-facets-form] input[type="radio"]')) {
      applyFacets();
    }
  });

  /* Enter en el buscador → mostrar resultados en el overlay (NO ir a /search).
     Sin JS, el formulario navega a /search como respaldo. */
  document.addEventListener('submit', function (e) {
    if (e.target.matches('[data-predictive-search-form]')) {
      e.preventDefault();
      var inp = e.target.querySelector('input[type="search"]');
      if (inp) searchByQuery(inp.value.trim());
    }
  });

  document.addEventListener('click', function (e) {
    // "Cargar más" → añade la siguiente página en el overlay
    var more = e.target.closest('[data-search-more]');
    if (more) {
      loadMore(more);
      return;
    }
    // móvil: abrir cajón de filtros
    if (e.target.closest('[data-search-filters-open]')) {
      var ofo = overlay();
      if (ofo) ofo.classList.add('is-filters-open');
      return;
    }
    // móvil: cerrar cajón de filtros ("Ver resultados" / ✕)
    if (e.target.closest('[data-search-filters-close]')) {
      var ofc = overlay();
      if (ofc) ofc.classList.remove('is-filters-open');
      return;
    }
    // abrir buscador → limpiar campo y mostrar populares (estado vacío)
    if (e.target.closest('[data-search-toggle]')) {
      var o = overlay();
      if (o) o.classList.remove('is-filters-open');
      positionOverlay();
      var inp = searchInput();
      if (inp) inp.value = '';
      var clr = o && o.querySelector('[data-search-clear]');
      if (clr) clr.hidden = true;
      loadPopular();
      showPopular();
      return;
    }
    // borrar texto
    var clear = e.target.closest('[data-search-clear]');
    if (clear) {
      var input = searchInput();
      if (input) { input.value = ''; input.focus(); }
      clear.hidden = true;
      showPopular();
      return;
    }
    // "limpiar filtros" dentro del overlay → volver a la búsqueda sin filtros
    var reset = e.target.closest('[data-search-reset]');
    if (reset) {
      var input2 = searchInput();
      if (input2 && input2.value.trim().length >= MIN_CHARS) {
        e.preventDefault();
        searchByQuery(input2.value.trim());
      }
    }
  });

  /* Flechas para navegar resultados con teclado. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var o = overlay();
    if (!o || !document.documentElement.classList.contains('search-drawer-open')) return;
    var links = Array.prototype.slice.call(o.querySelectorAll('.search-grid a, .product-grid a'));
    if (!links.length) return;
    var idx = links.indexOf(document.activeElement);
    if (idx === -1) return;
    e.preventDefault();
    var next = e.key === 'ArrowDown'
      ? (idx < links.length - 1 ? idx + 1 : 0)
      : (idx > 0 ? idx - 1 : links.length - 1);
    links[next].focus();
  });

  /* Acordeón de filtros: solo uno abierto a la vez, igual que en la colección.
     Va también aquí porque en la home no se carga facets.js y el overlay sí existe.
     El evento toggle de <details> no burbujea: se escucha en fase de captura. */
  document.addEventListener(
    'toggle',
    function (e) {
      var det = e.target;
      if (!det || det.nodeType !== 1 || !det.matches || !det.matches('[data-facet-group]') || !det.open) return;
      var abiertos = document.querySelectorAll('[data-facet-group][open]');
      for (var i = 0; i < abiertos.length; i++) {
        if (abiertos[i] !== det) abiertos[i].removeAttribute('open');
      }
    },
    true
  );

})();
